class ErrorAccessor {
  constructor(errors) {
    this.errors = errors;
  }
}
((ErrorAccessor2) => {
  ErrorAccessor2.normalizeError = (error) => typeof error === "string" ? {
    type: "validation",
    message: error,
    code: void 0
  } : error;
})(ErrorAccessor || (ErrorAccessor = {}));
export {
  ErrorAccessor
};
//# sourceMappingURL=ErrorAccessor.js.map
